import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../../messagerie_user/notification';
import ClassementEquipeArbitre from './classementEquipeArbitre';
import NavArbitre from '../../navigation/navArbitre';


const ClassementArbitre = () => {
  const Navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/verification/cookie`,
          {},
          {
            withCredentials: true 
          }
        );
        setUserData(response.data);
        setError(null);
        setIsLoading(false);
        if (response.data.user.type !== "arbitre") {
          Navigate('/connexion');
        }

      } catch (error) {
        if (error.response) {   
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        Navigate('/connexion')
        setIsLoading(false);

      }
    };

    fetchData(); 
  }, [Navigate, apiUrl]);
  


        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }

    return (
<>   
      {error && 
      <>
        <div id="alert-message" className="alert4" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
      </>  
        }
      {userData ? (
      <> 
          <NavArbitre userData={userData} nom='Tableau de bord'/>
          <div className='tableau-de-bord'>
              <Notification userData={userData}/>
              <ClassementEquipeArbitre/>
          </div>
        </>
              ) :(
                <>      
              <div id="alert-message" className="alert" >
                  <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
              </div></>
              )}
      </>
              
      );


}



export default ClassementArbitre;